import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslatorService } from '../../core/translator/translator.service';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { MessageBoxComponent } from '../../core/shared/message-box.component';
import { WorklogsRest } from '../worklogs.rest';
import { DictionaryRest } from '../../dictionaries/dictionary/dictionary.rest';
import { DateInputModel } from '../../core/shared/date-input/date-input.model';
import { NgxSelectComponent, INgxSelectOption } from 'ngx-select-ex';
import { LoginRest } from '../../login/login.rest';
import { WorklogRow } from '../worklogs.model';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { GridMainFilter, GoupedColumn, GroupFunction, SortedColumn, GridSelection, SelectionMode } from '../../core/shared/grid/grid.model';
import { GridParamsRestorable } from '../../core/services/grid-params-restoring/grid-params-restoring.model';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { IssueService } from '../../issues/issue.service';

const dateFromInternalName = 'DateFrom';
const dateToInternalName = 'DateTo';

@Component({
  selector: 'app-worklogs-list',
  templateUrl: './worklogs-list.component.html'
})
export class WorklogsListComponent extends GridSelection implements OnInit, AfterViewInit, HasPermissions, GridParamsRestorable {
  readonly detailsPath: string = '/worklogs/worklog';
  public path: string;

  public showSuccessMessage: boolean;
  public successMessage: string;

  public currentUser: any;
  public projectTypes: any;
  public customerRows: ObjectToSelect[];
  public usersRows: ObjectToSelect[];
  public initialFilters: any;
  public initialPageNumber = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public previousMainFilters: any = {};
  public editedItemId: number;

  private selectedCustomer: number;
  private selectedEmployee: number;
  private selectedProjectType: string;

  private startDate: DateInputModel;
  private endDate: DateInputModel;
  private isRestoredMainFilterDate: boolean = false;

  public hideToggles: boolean;
  public expanded: boolean;

  public mainFilter: GridMainFilter[];

  @ViewChild('employeeselect') selectEmployee: NgxSelectComponent;

  private headers = [
    { displayName: 'Numer', propertyName: 'numberString', propertyType: 'string' },
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
    { displayName: 'Data', propertyName: 'date', propertyType: 'date', isInitSort: true },
    { displayName: 'Projekt', propertyName: 'projectName', propertyType: 'string' },
    { displayName: 'Etap projektu', propertyName: 'projectStep', propertyType: 'string' },
    { displayName: 'Kontrahent', propertyName: 'customerCode', propertyType: 'string' },
    { displayName: 'Płatnik', propertyName: 'payerCode', propertyType: 'string' },
    { displayName: 'Czas pracy', propertyName: 'worktime', propertyType: 'string' },
    { displayName: 'Czas fakturowany', propertyName: 'billableTime', propertyType: 'string' },
    { displayName: 'Opis', propertyName: 'description', propertyType: 'string', showTooltip: true }
  ];

  private gridMenuButtons: MenuButton[] = [
    { text: 'COMMONBUTTONS_copy', class: 'btn-success', icon: '', onClick: () => { this.copy(); }, enabled: false, isForSelected: true }
  ];

  private columnsToGroup: GoupedColumn[] = [
    { name: 'worktime', func: GroupFunction.sum },
    { name: 'billableTime', func: GroupFunction.sum }
  ];

  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;

  public permissions: Permissions;
  private canRowBeShown: boolean;
  private canRowBeEdited: boolean;
  private canRowBeDeleted: boolean;
  private canRowBeAdded: boolean;
  private isEditable: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userRest: LoginRest,
    private translateService: TranslatorService,
    private worklogsRest: WorklogsRest,
    private dictionaryRest: DictionaryRest,
    private gridParamsRestoringService: GridParamsRestoringService,
    private spinnerService: SpinnerService,
    private permissionService: PermissionsService,
    private issueService: IssueService
  ) {
    super();
    this.onResize();

    this.selectionMode = this.selectionMode === SelectionMode.none ? SelectionMode.multi : this.selectionMode;
  }

  private copy() {
    var selectedItems = this.grid.getSelectedItems();

    if (selectedItems.length === 0) {
      sweetAlert('Nie zaznaczono elementu.');
      return;
    }

    if (selectedItems.length > 1) {
      sweetAlert('Zaznaczono więcej niż jeden element.');
      return;
    }
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../worklogs/worklog/copy', selectedItems[0].id], { queryParams: { id: selectedItems[0].id, isCopy: 1 }, relativeTo: this.route });
  }

  private changeState() {
    var selectedItems = this.grid.getSelectedItems();
  }

  ngOnInit() {
    this.spinnerService.show();
    this.mainFilter = new Array();
    this.tryRestoreFiltersAndPage();
    this.setPermissions('Worklog');

    this.setUpDates();
    if (this.permissions.canShow) {
      this.setupProjectTypes();
      this.setupCustomerRows();
      this.setupUsersRows();
    }
    this.setupCurrentUser();
    this.path = `api/worklogs/grid`;
  }

  ngAfterViewInit() {
    //this.grid.mainFilter = this.mainFilter;  
    this.filter();
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.route.data.subscribe(x => {
      this.permissions = this.permissionService.getUserPermissions(x.claimType);
      this.isEditable = this.permissions.canEdit || this.permissions.canShow;

      this.canRowBeShown = this.permissions.canShow;
      this.canRowBeAdded = this.permissions.canAdd;
      this.canRowBeEdited = this.permissions.canEdit;
      this.canRowBeDeleted = this.permissions.canDelete;
      this.gridMenuButtons.find(x => x.text === 'COMMONBUTTONS_copy').enabled = this.permissions.canAdd && this.permissions.canEdit;
    });
  }

  private setUpDates() {
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = false;
    this.startDate.isRequired = false;
    this.startDate.name = 'Od:';

    if (this.isRestoredMainFilterDate && this.previousMainFilters['FromDate'] && this.canRowBeShown) {
      this.startDate.value = new Date(this.previousMainFilters['FromDate']);
    } else {
      this.startDate.value = new Date();
      this.startDate.value.setHours(0, 0, 0, 0);
      this.startDate.value.setDate(1);
    }

    this.startDate.valueStr = this.startDate.value.toDateString();
    this.startDate.withTime = false;
    this.startDate.internalName = dateFromInternalName;

    this.endDate = new DateInputModel();
    this.endDate.isReadOnly = false;
    this.endDate.isRequired = false;
    this.endDate.name = 'Do:';

    if (this.isRestoredMainFilterDate && this.previousMainFilters['ToDate'] && this.canRowBeShown) {
      this.endDate.value = new Date(this.previousMainFilters['ToDate']);
    } else {
      this.endDate.value = new Date();
      this.endDate.value.setHours(23, 59, 59, 0);
    }

    this.endDate.valueStr = this.endDate.value.toDateString();
    this.endDate.withTime = false;
    this.endDate.internalName = dateToInternalName;
  }

  private setupProjectTypes() {
    this.dictionaryRest.getDictionaries(2).subscribe((dictionaries: any) => {
      this.projectTypes = dictionaries;
    });
  }

  private setupUsersRows() {
    var action;
    if (this.permissions.hasAllWorklogsPermission) {
      action = this.worklogsRest.getUsersRows;
    }
    else {
      action = this.worklogsRest.getSubordinates;
    }

    action.call(this.worklogsRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.usersRows = result.sort((x, y) => x.name > y.name ? 1 : -1);
      }
    });
  }

  private setupCustomerRows() {
    const action = this.worklogsRest.getCustomerRows;
    action.call(this.worklogsRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.customerRows = result;
      }
    });
  }

  private setupCurrentUser() {
    // if (!this.isRestoredMainFilter) {
    //   this.spinnerService.show();
    // }
    this.userRest.GetLoggedUser().subscribe((user: any) => {
      this.currentUser = user;
    });
  }

  private setDefaultfilters() {
    this.selectedEmployee = this.currentUser.employeeId;
    this.startDate.value = new Date();
    this.startDate.value.setHours(0, 0, 0, 0);
    this.startDate.value.setDate(1);
    this.endDate.value = new Date();
    this.endDate.value.setHours(23, 59, 59, 0);
  }

  private onDateValidation(date: DateInputModel, isValid: boolean) {
    if (!date) {
      return;
    }
    if (date.internalName === dateFromInternalName && this.startDate.value > this.endDate.value) {
      this.endDate.value = new Date(date.value);
      this.endDate.value.setHours(23, 59, 59, 0);
      this.startDate.value.setHours(0, 0, 0, 0);
    }
    else {
      this.endDate.value.setHours(23, 59, 59, 0);
    }


    if (date.internalName === dateToInternalName && date.value < this.startDate.value) {
      if (date.value != null) {
        this.startDate.value = new Date(date.value);
        this.startDate.value.setHours(0, 0, 0, 0);
        this.endDate.value.setHours(23, 59, 59, 0);
      }
      else {
        this.endDate.value.setHours(23, 59, 59, 0);
      }
    }
    else {
      this.endDate.value.setHours(23, 59, 59, 0);
    }
  }

  private selectedDates() {
    let startingdate = null;
    if (this.startDate.value != null) {
      startingdate = this.startDate.value.toJSON();
    }
    this.setFilterOnGrid('FromDate', startingdate);

    let endingDate = null;
    if (this.endDate.value != null) {
      endingDate = this.endDate.value.toJSON();
    }
    this.setFilterOnGrid('ToDate', endingDate);
  }

  private setFilterOnGrid(internalName: string, filterValue: string) {
    if (this.mainFilter != null) {
      this.mainFilter.forEach((item, index) => {
        if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
      });

      if (filterValue !== undefined) {
        this.mainFilter.push({ internalName: internalName, value: filterValue });
      }
      this.grid.mainFilter = this.mainFilter;
    }
  }

  public filter() {
    this.mainFilter = new Array();
    this.selectedDates();
    if (this.selectedEmployee) {
      this.setFilterOnGrid('EmployeeId', this.selectedEmployee.toString());
    }
    else
      this.setFilterOnGrid('EmployeeId', "0");

    if (this.selectedProjectType) {
      this.setFilterOnGrid('ProjectTypeName', this.selectedProjectType);
    }
    if (this.selectedCustomer) {
      this.setFilterOnGrid('CustomerId', this.selectedCustomer.toString());
    }

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  public clearFilter() {
    this.setDefaultfilters();
    this.selectedCustomer = null;
    this.selectedProjectType = null;
    this.filter();
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 768) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }

  private onRowDelete(row: WorklogRow) {
    sweetAlert('Czy chcesz usunąć RCP?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    }).then((value) => {
      switch (value) {
        case 'yes':
          const action = this.worklogsRest.deleteWorklog;
          action.call(this.worklogsRest, row.id).subscribe((result: String) => {
            if (result) {
              sweetAlert({ text: `Usunięto wpis RCP` });
              this.grid.refreshData(false);
            }
          });
          break;
      }
    });
  }

  private onRowEdit(row: WorklogRow) {
    this.issueService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['../worklogs/worklog', row.numberString], { queryParams: { id: row.id }, relativeTo: this.route });
  }

  private onRowAdd(value: any) {
    this.issueService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../worklogs/worklog/new'], { relativeTo: this.route });
  }

  private tryRestoreFiltersAndPage() {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if (!previousGridParams) {
      return;
    }

    this.initialFilters = previousGridParams.initialFilters;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
    this.previousMainFilters = previousGridParams.previousMainFilters;

    if (this.previousMainFilters['FromDate']) {
      this.mainFilter.push({ internalName: 'FromDate', value: this.previousMainFilters['FromDate'] });
    }
    if (this.previousMainFilters['ToDate']) {
      this.mainFilter.push({ internalName: 'ToDate', value: this.previousMainFilters['ToDate'] });
    }

    this.isRestoredMainFilterDate = true;
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }

  private setFiltersFromRestoredData() {
    const selectedEmployee = this.findFilter('EmployeeId');

    if (selectedEmployee != null)
      this.selectedEmployee = parseInt(selectedEmployee);

    const selectedCustomer = this.findFilter('CustomerId');
    this.selectedCustomer = selectedCustomer != null ? parseInt(selectedCustomer) : null;

    const selectedProjectType = this.findFilter('ProjectTypeName');
    this.selectedProjectType = selectedProjectType;// != null ? parseInt(selectedProjectType) : null;

    if (!this.isRestoredMainFilterDate) {
      const startDate = this.findFilter('FromDate');
      if (startDate != null) {
        this.startDate.value = new Date(startDate);
      } else {
        this.startDate.value = new Date();
        this.startDate.value.setDate(1);
      }

      const endDate = this.findFilter('ToDate');
      if (endDate != null) {
        this.endDate.value = new Date(endDate);
      } else {
        this.endDate.value = new Date();
      }
    }
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }

  public setGridMainFilterDates() {
    if (this.isRestoredMainFilterDate) {
      this.grid.mainFilter = this.mainFilter;
    }
  }
}
